import $ from 'jquery';

$(document).ready(function () {

    function resizeHandler() {
      var subMenuItem = document.querySelectorAll('#menu-primary .sub-menu');

      if (subMenuItem.length > 0) {
        subMenuItem.forEach((item) => {

          item.style.display = 'flex';
          let pos = item.getBoundingClientRect();

          if (pos.right > window.innerWidth) {
            item.style.right = 0;
            item.style.left = 'auto'
          } else {
            item.style.left = 0;
            item.style.right = 'auto'
          }

          item.style.display = '';
        })
      }
    }

  window.addEventListener('resize', resizeHandler);
})



// WEBPACK FOOTER //
// ./scripts/util/menu-fixer.js